export function btn(ctx) {
    return {
        styles: {
            // border_width: 2 matches BORDER_WIDTH (lv_theme_material.c:64, LV_DPX(2)) — was 1.
            // bg_color already comes from ctx.btnStyle (COLOR_BTN == COLOR_BG in dark palette);
            // no need to restate it here.
            main: { ...ctx.btnStyle, radius: 999, text_font: 32, border_width: 1 },
        },
    };
}
